import { ref, type Ref } from 'vue';

// Shared reactive ref for cross-component tab switching.
// Any component can write to this, and any tab component can watch it.
type TabRequest = { tab: string; alwaysScroll: boolean };

const activeTabOverride: Ref<TabRequest | null> = ref(null);

/**
 * Request a tab switch from any component (e.g., ButtonViews, EngagementBar).
 */
export const useActiveTabTrigger = () => {
  // alwaysScroll brings the tabs to the top even when part of them is already
  // on screen, for controls whose whole purpose is to show that tab.
  const requestTab = (tab: string, { alwaysScroll = false }: { alwaysScroll?: boolean } = {}) => {
    activeTabOverride.value = { tab, alwaysScroll };
  };

  return { requestTab };
};

/**
 * Watch for external tab switch requests in tab components.
 */
export const useActiveTabListener = () => {
  return { activeTabOverride };
};
